import { TriggerActionCategory } from "@octopusdeploy/octopus-server-client";
import { CreateOrEditScheduledTriggerPage } from "../../Triggers/Scheduled/CreateOrEditScheduledTriggerPage";
interface RunbookScheduledTriggerPageProps {
    spaceId: string;
    projectSlug: string;
    triggerId: string;
}
export function RunbookScheduledTriggerPage({ spaceId, projectSlug, triggerId }: RunbookScheduledTriggerPageProps) {
    return <CreateOrEditScheduledTriggerPage create={false} triggerActionCategory={TriggerActionCategory.Runbook} triggerId={triggerId} spaceId={spaceId} projectSlug={projectSlug}/>;
}
